import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm, FormProvider, Controller } from "react-hook-form";
import SelectPersonnel from "../select/SelectPersonnel";
import { addFromReferences, getReferences } from "../../api/HolidayApi";
import GlobalContext from "../../context/GlobalContext";
import BoxSkeleton from "../utilities/BoxSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightFromBracket,
  faDownload,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import swal from "../../services/swalConfig";

import { tr } from "../../i18n";
const ModalHolidayReferences = ({ show, onClose, onSuccess }) => {
  const { user, setLoading } = useContext(GlobalContext);
  const companyId = user.workspace.company_id;
  const [selectAll, setSelectAll] = useState(false);

  const methods = useForm({
    defaultValues: {
      holidays: [],
    },
  });

  const { handleSubmit, setValue, watch, control } = methods;
  const holidays = watch("holidays");

  useEffect(() => {
    if (show && companyId) {
      getReferences(companyId).then((res) => {
        if (res.status === 200 && Array.isArray(res.data)) {
          const formatted = res.data.map((item, index) => ({
            id: index,
            company_id: companyId,
            date: item.date,
            name: item.name,
            reduce_paid_leave: item.is_deduct_leave,
            selected: false,
            exceptions: [],
          }));
          setValue("holidays", formatted, { shouldValidate: true });
        } else if (res.status === 200 && res.data?.data) {
          const formatted = res.data.data.map((item, index) => ({
            id: index,
            company_id: companyId,
            date: item.date,
            name: item.name,
            reduce_paid_leave: item.is_deduct_leave,
            selected: false,
            exceptions: [],
          }));
          setValue("holidays", formatted, { shouldValidate: true });
        }
      });
    }
  }, [show, companyId, setValue]);

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    const updated = holidays.map((h) => ({
      ...h,
      selected: checked,
    }));
    setValue("holidays", updated);
  };

  const handleSelectRow = (id, checked) => {
    const updated = holidays.map((h) =>
      h.id === id ? { ...h, selected: checked } : h,
    );
    setValue("holidays", updated);
  };

  const handleDeductLeave = (id, checked) => {
    const updated = holidays.map(
      (h) => (h.id === id ? { ...h, reduce_paid_leave: checked } : h), // Ubah is_deduct_leave menjadi reduce_paid_leave
    );
    setValue("holidays", updated);
  };

  const submitHandler = async (data) => {
    const selectedHolidays = data.holidays.filter((h) => h.selected);

    setLoading(true);

    try {
      const response = await addFromReferences(selectedHolidays);

      if (response.status === 200) {
        onSuccess();
      }

      swal.fire({
        title: response.status === 200 ? tr("shared:success") : tr("common:errors.oops"),
        text: response.message,
        icon: response.status === 200 ? "success" : "error",
        showCancelButton: false,
      });
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("common:errors.generic"),
        icon: "error",
      });
    } finally {
      setLoading(false);
    }

    onClose();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(submitHandler)}>
          <Modal.Header closeButton>
            <Modal.Title>{tr("attendance:holiday_references")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "400px",
              }}
            >
              <table
                style={{
                  width: "100%",
                  fontSize: "10pt",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                  flexShrink: 0,
                  borderRadius: 0,
                  borderTopLeftRadius: "19px",
                  borderTopRightRadius: "19px",
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        width: "5%",
                        padding: "8px",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      <Form.Check
                        type="checkbox"
                        checked={selectAll}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                    </th>
                    <th
                      style={{
                        width: "35%",
                        padding: "8px",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      {tr("attendance:event")}
                    </th>
                    <th
                      style={{
                        width: "20%",
                        padding: "8px",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      {tr("attendance:date")}
                    </th>
                    <th
                      style={{
                        width: "30%",
                        padding: "8px",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      {tr("attendance:exceptions")}
                    </th>
                    <th
                      style={{
                        width: "10%",
                        padding: "8px",
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      {tr("attendance:reduce_paid_leave")}
                    </th>
                  </tr>
                </thead>
              </table>
              <div
                style={{
                  overflowY: "auto",
                  flexGrow: 1,
                  border: "1px solid #dee2e6",
                  borderTop: "none",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    fontSize: "10pt",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                  }}
                >
                  <tbody>
                    {holidays && holidays.length > 0 ? (
                      (holidays || []).map((holiday, idx) => (
                        <tr key={holiday.id}>
                          <td style={{ width: "5%", padding: "8px" }}>
                            <Form.Check
                              type="checkbox"
                              checked={!!holiday.selected}
                              onChange={(e) =>
                                handleSelectRow(holiday.id, e.target.checked)
                              }
                            />
                          </td>
                          <td style={{ width: "35%", padding: "8px" }}>
                            {holiday.name}
                          </td>
                          <td style={{ width: "20%", padding: "8px" }}>
                            {formatDate(holiday.date)}
                          </td>
                          <td
                            style={{
                              width: "30%",
                              padding: "8px",
                              minWidth: "220px",
                            }}
                          >
                            <Controller
                              name={`holidays.${idx}.exceptions`}
                              control={control}
                              render={({ field }) => (
                                <SelectPersonnel
                                  value={field.value}
                                  onChange={field.onChange}
                                  name={field.name}
                                  isMulti={true}
                                  placeholder={tr("attendance:select_exceptions")}
                                />
                              )}
                            />
                          </td>
                          <td
                            style={{
                              width: "10%",
                              padding: "8px",
                              textAlign: "center",
                            }}
                          >
                            <Form.Check
                              id={`deduct-${holiday.id}`} // Tambahkan ID unik
                              name={`holidays.${idx}.reduce_paid_leave`}
                              type="checkbox"
                              checked={Boolean(holiday.reduce_paid_leave)} // Pastikan selalu boolean
                              onChange={(e) =>
                                handleDeductLeave(holiday.id, e.target.checked)
                              }
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5">
                          <BoxSkeleton count="8" size="15" height="30px" />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>
              {tr("common:actions.cancel")}
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm"
            >
              <FontAwesomeIcon icon={faArrowRightFromBracket} />
              {tr("attendance:import_from_references")}
            </Button>
          </Modal.Footer>
        </Form>
      </FormProvider>
    </Modal>
  );
};

export default ModalHolidayReferences;
